{
  "steplist": "Список кроків"
}
